import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { Card, Row, Col, Form, Input, Button,
	Select, message, Alert, Spin, TimePicker, Switch,
	Typography, Divider,
} from 'antd';
import {
	CheckCircleOutlined, CloseCircleOutlined, UserOutlined,
	BankOutlined, EnvironmentOutlined, ClockCircleOutlined,
	PhoneOutlined, HomeOutlined, SaveOutlined, ApartmentOutlined,
	SettingOutlined, CalendarOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import Config from '../../Config';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, ajaxHandler, setConfig, extractResult } from '../../store/actions';
import { Helmet } from 'react-helmet';
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	title: 'Form UPT',
	apiUrl: {
		preview:   'pegawai/api/upt/',
		kabupaten: 'master/api/kabupaten/',
		pegawai:   'pegawai/api/pegawai/',
		upt:       'pegawai/api/upt/',
	},
	pageUrl: { data: '/admin/upt/' },
	breadCrumb: ['Pegawai', 'UPT', 'Form'],
};

const config = new Config();

const HARI_OPTIONS = [
	{ value: 0, label: 'Senin' },
	{ value: 1, label: 'Selasa' },
	{ value: 2, label: 'Rabu' },
	{ value: 3, label: 'Kamis' },
	{ value: 4, label: 'Jumat' },
	{ value: 5, label: 'Sabtu' },
	{ value: 6, label: 'Minggu' },
];

const sectionCard = (title, icon, color, children) => (
	<Card
		style={{
			borderRadius: 14,
			boxShadow: '0 4px 20px rgba(0,0,0,0.07)',
			overflow: 'hidden',
			marginBottom: 20,
		}}
		bodyStyle={{ padding: 0 }}
	>
		<div style={{
			padding: '13px 22px',
			background: `linear-gradient(135deg, ${color}22, ${color}11)`,
			borderBottom: `2px solid ${color}33`,
			display: 'flex', alignItems: 'center', gap: 10,
		}}>
			<span style={{ color, fontSize: 17 }}>{icon}</span>
			<Text strong style={{ fontSize: 14, color: '#222' }}>{title}</Text>
		</div>
		<div style={{ padding: '22px 26px' }}>{children}</div>
	</Card>
);

class FormUpt extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,
			aksi: 'tambah',
			method: 'post',
			idLama: '',

			listKabupaten: [], loadingKabupaten: false,
			listPegawai:   [], loadingPegawai: false,
			listUpt:       [], loadingUpt: false,

			is_bypass: false,
			is_pusat:  false,
			is_stnk:   false,
			is_other:  false,

			previewNama: '',
			previewKabupaten: '',
		};
	}

	UNSAFE_componentWillMount() { this.props.initHandler(); }

	componentDidMount() { this.loadMasterList(); }

	loadMasterList() {
		const rules = [
			{
				destination: { stateProgressName: 'loadingKabupaten', endPoint: configClass.apiUrl.kabupaten, stateDestination: 'listKabupaten' },
				nextDestination: {
					stateProgressName: 'loadingPegawai', endPoint: configClass.apiUrl.pegawai, stateDestination: 'listPegawai',
					next: {
						stateProgressName: 'loadingUpt', endPoint: configClass.apiUrl.upt, stateDestination: 'listUpt',
						next: null,
					},
				},
			},
		];
		this.setState({ errComponent: false });
		rules.forEach((item, index) => this.getMasterList(item, index === rules.length - 1));
	}

	async getMasterList(rule, isFinal = false) {
		const { destination, nextDestination } = rule;
		this.setState({ [destination.stateProgressName]: true });
		this.props.ajaxViewHandler('get', destination.endPoint)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					if (data.count !== undefined) {
						const oldState = this.state[destination.stateDestination];
						let newState;
						if (oldState.length === 0) {
							newState = data;
						} else if (destination.stateProgressName.includes('_searching')) {
							newState = data;
						} else {
							newState = { count: data.count, next: data.next, previous: data.previous, results: [...oldState.results, ...data.results] };
						}
						this.setState({ [destination.stateDestination]: newState });
					} else if (data.results !== undefined) {
						this.setState({ [destination.stateDestination]: data.results });
					} else {
						this.setState({ [destination.stateDestination]: Array.isArray(data) ? data : [data] });
					}
					if (isFinal && this.props.match.params.id !== undefined) {
						this.preview(this.props.match.params.id);
					}
				} else {
					this.setState({ errComponent: true });
				}
				this.setState({ [destination.stateProgressName]: false });
			})
			.catch(() => {
				message.error({ content: 'Gagal request data master', duration: 2, key: 'toast' });
				this.setState({ [destination.stateProgressName]: false });
			});
		if (nextDestination) {
			this.getMasterList({ destination: nextDestination, nextDestination: nextDestination.next });
		}
	}

	async preview(id) {
		message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					this.formRef.current.setFieldsValue(data);
					for (const key in data) {
						const timeRegex = /^[0-9]{2}:[0-9]{2}:[0-9]{2}$/;
						if (timeRegex.test(data[key])) {
							this.formRef.current.setFieldsValue({
								[key + '_picker']: moment(data[key], 'HH:mm'),
							});
						} else if (key === 'is_bypass') {
							this.setState({ is_bypass: data[key] });
						} else if (key === 'is_pusat') {
							this.setState({ is_pusat: data[key] });
						} else if (key === 'is_stnk') {
							this.setState({ is_stnk: data[key] });
						} else if (key === 'is_other') {
							this.setState({ is_other: !!data[key] });
						}
					}
					this.setState({
						aksi: 'edit',
						method: 'put',
						idLama: id + '/',
						previewNama: data.nama || '',
					});
					message.destroy();
				} else {
					this.setState({ errTitle: 'Gagal memuat data', errMsg: data });
					message.error({ content: 'Gagal memuat data', duration: 2, key: 'toast' });
				}
			})
			.catch(() => message.error({ content: 'Gagal request data', duration: 2, key: 'toast' }));
	}

	handleSubmit = (values) => { this.postData(values); };

	async postData(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.setState({ loadingButton: true });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
				} else {
					const errTitle = 'Gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data', duration: 2, key: 'toast' });
			});
	}

	generateSelect(stateName, url, key, value, keyDisplay = '') {
		const loading = this.state['loading' + stateName];
		const list    = this.state['list' + stateName];
		if (loading) return <Spin size="small" />;
		return (
			<Select
				showSearch
				placeholder={'Cari / Pilih ' + stateName}
				optionFilterProp="children"
				allowClear
				size="large"
				style={{ width: '100%' }}
				onSearch={(val) => {
					this.getMasterList({
						destination: {
							stateProgressName: 'loading' + stateName + '_searching',
							endPoint: url + '?search=' + val,
							stateDestination: 'list' + stateName,
						},
						nextDestination: null,
					});
				}}
				onPopupScroll={(e) => {
					e.persist();
					const target = e.target;
					if (target.scrollTop + target.offsetHeight === target.scrollHeight) {
						const next = (list.count !== undefined ? list : {}).next;
						if (next) {
							this.getMasterList({
								destination: {
									stateProgressName: 'loading' + stateName + 'Paging',
									endPoint: next,
									stateDestination: 'list' + stateName,
								},
								nextDestination: null,
							});
						}
					}
				}}
			>
				{this.state['loading' + stateName + '_searching'] && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
				{(list.count !== undefined ? list.results : list).map((item) => (
					<Select.Option key={item[key]} value={item[key]}>
						{keyDisplay === '' ? `${item[key]} — ${item[value]}` : `${item[keyDisplay]} — ${item[value]}`}
					</Select.Option>
				))}
				{list.next && (
					<Select.Option value=""><Spin size="small" /></Select.Option>
				)}
			</Select>
		);
	}

	render() {
		if (this.props.isRedirect) return <Redirect to={configClass.pageUrl.data} />;

		const { loadingButton, errMsg, errTitle, aksi, is_pusat, is_bypass, is_stnk, is_other, previewNama } = this.state;
		const isEdit = aksi === 'edit';

		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-upt-wrap .ant-input,
						.form-upt-wrap .ant-input-affix-wrapper input,
						.form-upt-wrap .ant-select-selection-search-input,
						.form-upt-wrap .ant-select-selection-item,
						.form-upt-wrap .ant-select-item-option-content {
							text-transform: none !important;
						}
						.form-upt-wrap .ant-input-lg,
						.form-upt-wrap .ant-input-affix-wrapper-lg,
						.form-upt-wrap .ant-select-lg .ant-select-selector {
							border-radius: 8px !important;
						}
						.form-upt-wrap .ant-form-item-label > label {
							font-weight: 600;
							color: #444;
						}
						.form-upt-wrap .ant-picker {
							width: 100%;
							border-radius: 8px;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errMsg: '', errTitle: '' })}
				/>

				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					initialValues={{ is_other: false }}
					className="form-upt-wrap"
				>
					<Row gutter={[20, 0]}>

						{/* ===== KOLOM KIRI — Info Card ===== */}
						<Col xs={24} md={7}>
							<Card
								style={{
									borderRadius: 14,
									boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
									overflow: 'hidden',
									marginBottom: 20,
									position: 'sticky',
									top: 20,
								}}
								bodyStyle={{ padding: 0 }}
							>
								{/* Banner */}
								<div style={{
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									padding: '36px 20px 60px',
									textAlign: 'center',
								}}>
									<div style={{
										width: 80, height: 80,
										borderRadius: '50%',
										background: 'rgba(255,255,255,0.2)',
										border: '3px solid rgba(255,255,255,0.4)',
										display: 'flex', alignItems: 'center', justifyContent: 'center',
										margin: '0 auto',
										fontSize: 32,
									}}>
										<BankOutlined style={{ color: '#fff' }} />
									</div>
								</div>

								{/* Info summary */}
								<div style={{ padding: '0 22px 22px', marginTop: -36, textAlign: 'center' }}>
									<div style={{
										background: '#fff',
										borderRadius: 12,
										padding: '16px 18px',
										boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
									}}>
										{isEdit ? (
											<>
												<div style={{ fontWeight: 700, fontSize: 15, color: '#222', lineHeight: 1.3 }}>
													{previewNama || '—'}
												</div>
												<div style={{ color: '#888', fontSize: 12, marginTop: 6 }}>
													UPT Terdaftar
												</div>
											</>
										) : (
											<>
												<div style={{ fontWeight: 700, fontSize: 14, color: '#222' }}>UPT Baru</div>
												<div style={{ color: '#aaa', fontSize: 12, marginTop: 4 }}>Lengkapi formulir di samping</div>
											</>
										)}
									</div>

									<Divider style={{ margin: '18px 0 14px' }} />

									{/* Tombol aksi */}
									<div style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
										<Button
											type="primary"
											htmlType="submit"
											icon={<SaveOutlined />}
											size="large"
											loading={loadingButton}
											disabled={this.state.errComponent}
											style={{
												borderRadius: 10, width: '100%', fontWeight: 600,
												background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
												border: 'none',
											}}
										>
											{isEdit ? 'Simpan Perubahan' : 'Tambah UPT'}
										</Button>
										<Link to={configClass.pageUrl.data}>
											<Button
												size="large"
												icon={<CloseCircleOutlined />}
												style={{ borderRadius: 10, width: '100%' }}
											>
												Batal
											</Button>
										</Link>
									</div>
								</div>
							</Card>
						</Col>

						{/* ===== KOLOM KANAN — Section Cards ===== */}
						<Col xs={24} md={17}>

							{/* SECTION: Identitas UPT */}
							{sectionCard('Identitas UPT', <BankOutlined />, '#1890ff',
								<Row gutter={16}>
									<Col xs={24} md={12}>
										<Form.Item
											label="Kode UPT"
											name="kode"
											rules={[{ required: true, message: 'Kode UPT wajib diisi' }]}
										>
											<Input
												placeholder="Contoh: UPT001"
												size="large"
												style={{ textTransform: 'none' }}
											/>
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											label="Kode Jasa Raharja"
											name="kode_jasaraharja"
											rules={[{ required: true, message: 'Kode Jasa Raharja wajib diisi' }]}
										>
											<Input
												placeholder="Kode Jasa Raharja"
												size="large"
												style={{ textTransform: 'none' }}
											/>
										</Form.Item>
									</Col>
									<Col xs={24}>
										<Form.Item
											label="Nama UPT"
											name="nama"
											rules={[{ required: true, message: 'Nama UPT wajib diisi' }]}
										>
											<Input
												placeholder="Nama lengkap UPT"
												size="large"
												style={{ textTransform: 'none' }}
												onChange={(e) => this.setState({ previewNama: e.target.value })}
											/>
										</Form.Item>
									</Col>
									<Col xs={24}>
										<Form.Item
											label="Kabupaten"
											name="kabupaten"
											rules={[{ required: true, message: 'Kabupaten wajib dipilih' }]}
										>
											{this.generateSelect('Kabupaten', configClass.apiUrl.kabupaten, 'id', 'name')}
										</Form.Item>
									</Col>
								</Row>
							)}

							{/* SECTION: Kontak & Lokasi */}
							{sectionCard('Kontak & Lokasi', <EnvironmentOutlined />, '#52c41a',
								<Row gutter={16}>
									<Col xs={24} md={12}>
										<Form.Item
											label="No. Telepon"
											name="telpon"
											rules={[{ required: true, message: 'Telepon wajib diisi' }]}
										>
											<Input
												prefix={<PhoneOutlined style={{ color: '#bbb' }} />}
												placeholder="Contoh: 0511-xxxxx"
												size="large"
												style={{ textTransform: 'none' }}
											/>
										</Form.Item>
									</Col>
									<Col xs={24} md={12}>
										<Form.Item
											label="Korektor"
											name="korektor"
											rules={[{ required: true, message: 'Korektor wajib dipilih' }]}
										>
											{this.generateSelect('Pegawai', configClass.apiUrl.pegawai, 'id', 'nama')}
										</Form.Item>
									</Col>
									<Col xs={24}>
										<Form.Item
											label="Alamat"
											name="alamat"
											rules={[{ required: true, message: 'Alamat wajib diisi' }]}
										>
											<Input.TextArea
												placeholder="Alamat lengkap UPT"
												rows={3}
												style={{ textTransform: 'none', borderRadius: 8 }}
											/>
										</Form.Item>
									</Col>
								</Row>
							)}

							{/* SECTION: Jam Operasional */}
							{sectionCard('Jam Operasional', <ClockCircleOutlined />, '#fa8c16',
								<Row gutter={16}>
									<Col xs={24}>
										<Form.Item
											label="Hari Operasional"
											name="hari"
											rules={[{ required: true, message: 'Hari wajib dipilih' }]}
										>
											<Select
												mode="multiple"
												placeholder="Pilih hari operasional"
												size="large"
												style={{ width: '100%' }}
												optionFilterProp="children"
											>
												{HARI_OPTIONS.map(h => (
													<Select.Option key={h.value} value={h.value}>{h.label}</Select.Option>
												))}
											</Select>
										</Form.Item>
									</Col>
									<Col xs={24} sm={12}>
										<Form.Item
											label="Jam Mulai"
											name="mulai_dari_picker"
											rules={[{ required: true, message: 'Jam mulai wajib diisi' }]}
										>
											<TimePicker
												format="HH:mm"
												size="large"
												placeholder="Pilih jam mulai"
												onChange={(_, timeString) => {
													this.formRef.current.setFieldsValue({ mulai_dari: timeString });
												}}
											/>
										</Form.Item>
										<Form.Item name="mulai_dari" style={{ display: 'none' }}>
											<Input type="hidden" />
										</Form.Item>
									</Col>
									<Col xs={24} sm={12}>
										<Form.Item
											label="Jam Selesai"
											name="sampai_dengan_picker"
											rules={[{ required: true, message: 'Jam selesai wajib diisi' }]}
										>
											<TimePicker
												format="HH:mm"
												size="large"
												placeholder="Pilih jam selesai"
												onChange={(_, timeString) => {
													this.formRef.current.setFieldsValue({ sampai_dengan: timeString });
												}}
											/>
										</Form.Item>
										<Form.Item name="sampai_dengan" style={{ display: 'none' }}>
											<Input type="hidden" />
										</Form.Item>
									</Col>
								</Row>
							)}

							{/* SECTION: Konfigurasi */}
							{sectionCard('Konfigurasi', <SettingOutlined />, '#722ed1',
								<Row gutter={16}>
									<Col xs={24} sm={12}>
										<Form.Item label="Kantor Pusat" name="is_pusat_picker">
											<div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingTop: 6 }}>
												<Switch
													checked={is_pusat}
													onChange={(val) => {
														// Jika pusat diaktifkan, reset bypass & stnk
														const newState = { is_pusat: val };
														if (val) {
															newState.is_bypass = false;
															newState.is_stnk   = false;
															this.formRef.current.setFieldsValue({ is_bypass: false, is_stnk: false });
														}
														this.setState(newState);
														this.formRef.current.setFieldsValue({ is_pusat: val });
													}}
												/>
												<Text style={{ color: is_pusat ? '#722ed1' : '#aaa' }}>
													{is_pusat ? 'Ya, Kantor Pusat' : 'Bukan Kantor Pusat'}
												</Text>
											</div>
										</Form.Item>
										<Form.Item name="is_pusat" style={{ display: 'none' }}>
											<Input type="hidden" />
										</Form.Item>
									</Col>

									<Col xs={24} sm={12}>
										<Form.Item label="Mode Bypass" name="is_bypass_picker">
											<div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingTop: 6 }}>
												<Switch
													disabled={is_pusat}
													checked={is_bypass}
													onChange={(val) => {
														// Jika bypass dimatikan, reset stnk
														const newState = { is_bypass: val };
														if (!val) {
															newState.is_stnk = false;
															this.formRef.current.setFieldsValue({ is_stnk: false });
														}
														this.setState(newState);
														this.formRef.current.setFieldsValue({ is_bypass: val });
													}}
												/>
												<Text style={{ color: is_pusat ? '#ccc' : is_bypass ? '#fa8c16' : '#aaa' }}>
													{is_pusat ? 'Tidak tersedia (Kantor Pusat)' : is_bypass ? 'Bypass Aktif' : 'Bypass Nonaktif'}
												</Text>
											</div>
										</Form.Item>
										<Form.Item name="is_bypass" style={{ display: 'none' }}>
											<Input type="hidden" />
										</Form.Item>
									</Col>

									<Col xs={24} sm={12}>
										<Form.Item label="Aktifkan 5 Tahun STNK" name="is_stnk_picker">
											<div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingTop: 6 }}>
												<Switch
													disabled={is_pusat || !is_bypass}
													checked={is_stnk}
													onChange={(val) => {
														this.setState({ is_stnk: val });
														this.formRef.current.setFieldsValue({ is_stnk: val });
													}}
												/>
												<Text style={{ color: (is_pusat || !is_bypass) ? '#ccc' : is_stnk ? '#13c2c2' : '#aaa' }}>
													{is_pusat
														? 'Tidak tersedia (Kantor Pusat)'
														: !is_bypass
															? 'Aktifkan Bypass terlebih dahulu'
															: is_stnk ? 'Aktif' : 'Nonaktif'}
												</Text>
											</div>
										</Form.Item>
										<Form.Item name="is_stnk" style={{ display: 'none' }}>
											<Input type="hidden" />
										</Form.Item>
									</Col>

									<Col xs={24} sm={12}>
										<Form.Item label="UPT Online (Bukan Fisik)" name="is_other_picker">
											<div style={{ display: 'flex', alignItems: 'center', gap: 12, paddingTop: 6 }}>
												<Switch
													checked={is_other}
													onChange={(val) => {
														this.setState({ is_other: val });
														this.formRef.current.setFieldsValue({ is_other: val });
													}}
												/>
												<Text style={{ color: is_other ? '#1890ff' : '#aaa' }}>
													{is_other ? 'Ya, Layanan Online' : 'UPT Fisik / Samsat Keliling'}
												</Text>
											</div>
										</Form.Item>
										<Form.Item name="is_other" style={{ display: 'none' }}>
											<Input type="hidden" />
										</Form.Item>
									</Col>

									<Col xs={24}>
										<Form.Item
											label="UPT Sumber Notice"
											name="upt_sumber_notice"
											extra="Khusus UPT online (Signal/ePahari/Huma Betang, dll) yang fisiknya berbagi satu box notice yang sama - nomor notice akan diambil dari counter/box milik UPT yang dipilih di sini, bukan milik UPT ini sendiri. Kosongkan kalau UPT ini punya box notice sendiri."
										>
											{this.generateSelect('Upt', configClass.apiUrl.upt, 'id', 'nama')}
										</Form.Item>
									</Col>
									<Col xs={24}>
										<div style={{
											background: '#f9f0ff',
											border: '1px solid #d3adf7',
											borderRadius: 10,
											padding: '12px 16px',
											fontSize: 13,
											color: '#531dab',
											lineHeight: 1.6,
										}}>
											<strong>Keterangan:</strong>
											<ul style={{ margin: '6px 0 0', paddingLeft: 20 }}>
												<li><strong>Kantor Pusat</strong> — UPT ini merupakan kantor induk/pusat wilayah. Jika aktif, Bypass dan 5 Tahun STNK dinonaktifkan.</li>
												<li><strong>Bypass</strong> — Mengizinkan transaksi tanpa validasi normal. Hanya tersedia jika bukan Kantor Pusat.</li>
												<li><strong>Aktifkan 5 Tahun STNK</strong> — Wajibkan layanan Pendaftaran Ulang 5 Tahun saat masa berlaku STNK habis tahun ini. Hanya tersedia jika Bypass aktif.</li>
												<li><strong>UPT Online (Bukan Fisik)</strong> — Aktifkan untuk UPT layanan online (Signal, ePahari, Huma Betang, dll) yang tidak punya kantor/loket fisik. UPT ini akan disembunyikan dari dropdown pilih UPT untuk user level biasa.</li>
												<li><strong>UPT Sumber Notice</strong> — Dipakai saat beberapa UPT online berbagi satu box notice fisik, supaya nomor yang diterbitkan tidak bentrok antar UPT.</li>
											</ul>
										</div>
									</Col>
								</Row>
							)}

							{/* Tombol aksi bawah (untuk mobile agar tidak perlu scroll ke atas) */}
							<div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginBottom: 20 }}>
								<Link to={configClass.pageUrl.data}>
									<Button size="large" icon={<CloseCircleOutlined />} style={{ borderRadius: 10 }}>
										Batal
									</Button>
								</Link>
								<Button
									type="primary"
									htmlType="submit"
									icon={<SaveOutlined />}
									size="large"
									loading={loadingButton}
									disabled={this.state.errComponent}
									style={{
										borderRadius: 10, fontWeight: 600, minWidth: 150,
										background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
										border: 'none',
									}}
								>
									{isEdit ? 'Simpan Perubahan' : 'Tambah UPT'}
								</Button>
							</div>

						</Col>
					</Row>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = state => state.configReducers;

export default connect(
	mapStateToProps,
	{ initHandler, setConfig, ajaxViewHandler, ajaxHandler }
)(FormUpt);
